import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ActivitiesList from './ActivitiesList';
import ActivityEdit from './ActivityEdit';

export class ActivitiesManagement extends React.Component {
  componentDidMount () {
    const { fetchActivities } = this.props;
    fetchActivities();
  }

  render () {
    const { match: { path } } = this.props;

    return (
      <Switch>
        <Route
          path={`${path}/:key`}
        >
          <ActivityEdit
            listPath={path}
          />
        </Route>
        <Route
          path={path}
        >
          <ActivitiesList
            listPath={path}
          />
        </Route>
      </Switch>
    );
  }
}

export default ActivitiesManagement;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivitiesManagement.js